import { useRef, useState } from 'react';

import { UseContentListActionReturn, ContentListAction } from '../../model';

import { useUpdateContentsFolderMutation, useDeleteContentsMutation } from '../mutation';

export function useContentListAction(): UseContentListActionReturn {
	const [selectedContentIds, setSelectedContentIds] = useState<number[]>([]);
	const selectedFolderId = useRef<Record<number, number>>({});

	const updateFolder = useUpdateContentsFolderMutation(selectedContentIds, selectedFolderId);
	const deleteContents = useDeleteContentsMutation(
		selectedContentIds,
		selectedFolderId,
		setSelectedContentIds,
	);

	async function dispatch(action: ContentListAction) {
		switch (action.type) {
			case 'SELECT_CONTENT':
				setSelectedContentIds((prev) => {
					if (prev.includes(action.contentId)) {
						if (selectedFolderId.current[action.folderId] > 1) {
							selectedFolderId.current[action.folderId] -= 1;
						} else {
							delete selectedFolderId.current[action.folderId];
						}
						return prev.filter((id) => id !== action.contentId);
					}

					selectedFolderId.current[action.folderId] = selectedFolderId.current[
						action.folderId
					]
						? selectedFolderId.current[action.folderId] + 1
						: 1;
					return [...prev, action.contentId];
				});
				break;

			case 'UPDATE_FOLDER':
				await updateFolder({
					updateFolderId: action.folderId,
					updateFolderName: action.folderName,
				});
				setSelectedContentIds([]);
				break;

			case 'DELETE_CONTENTS':
				deleteContents();
				break;

			case 'CLEAR_SELECTED_CONTENT':
				setSelectedContentIds([]);
				break;

			default:
				throw new Error('Invalid action');
		}
	}

	return {
		selectedContentIds,
		selectedFolderIds: Object.keys(selectedFolderId.current).map(Number),
		dispatch,
	};
}
